import { useContext, useEffect, useState } from "react";
import { Button, Form, FormCheck, FormControl, FormGroup, FormLabel } from "react-bootstrap";
import { ReactReduxContext, useDispatch } from "react-redux";
import { AZIENDA_UID } from "../constants/ParametriCalcolatore";
import { RESET_STEPS } from "../constants/ActionTypes";
import { useWizard } from "react-use-wizard";
import { useLocation } from "react-router-dom";
import { useLoader } from '../utils/hooks';
import axios from "axios";
import Swal from "sweetalert2";
import FormCheckInput from "react-bootstrap/esm/FormCheckInput";
import FormCheckLabel from "react-bootstrap/esm/FormCheckLabel";

function Step6() {
    const { store } = useContext(ReactReduxContext);
    const dispatch = useDispatch();
    const { goToStep } = useWizard();
    const location = useLocation();
    const [error, setError] = useState(false);
    const [leadData, setLeadData] = useState({
        full_name: null,
        company_name: null,
        business_address: null,
        city: null,
        email: null,
        phone_number: null,
        risposte: [],
        utmSource: null,
        utmCampaign: null,
        azienda: AZIENDA_UID,
    });
    const loader = useLoader({ height: 546 });

    const calcola = () => {
        const data = { ...leadData };

        data.risposte = [];

        store.getState().steps.forEach(step => {
            data.risposte.push({ 'domanda': step.question, 'risposta': step.answer, 'valore': step.value });
        });

        data.utmSource = store.getState().utmSource;
        data.utmCampaign = store.getState().utmCampaign;

        setLeadData(data);
    }

    const backToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    useEffect(() => {
        if (location.pathname === '/') {
            dispatch({
                type: RESET_STEPS,
            });

            backToTop();

            goToStep(0);
        }
    }, [location]);

    useEffect(() => {
        loader.setStartLoading();
        loader.setEndLoading(3);
        calcola();
    }, []);

    const validateEmail = (value) => {
        setError(false);

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) setError(true);
    };

    const handleChange = (e) => {
        const data = { ...leadData };
        data[e.target.name] = e.target.value;
        setLeadData(data);
        if (e.target.name === 'email') validateEmail(e.target.value);
    };

    const insertLead = async (e) => {
        e.preventDefault();

        if (error) {
            Swal
                .fire({
                    title: `Insert a valid email address`,
                    icon: `error`,
                    confirmButtonText: `Close`
                });
            return false;
        }

        // window.dataLayer.push({
        //     event: `submit_form_calcolatore`
        // });

        loader.watchPromise(
            axios
                .post(
                    '/send-email/external-lead',
                    {
                        data: leadData,
                    },
                    {
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                )
                .then((res) => {
                    if (res.data.status === 200) {
                        Swal
                            .fire({
                                title: `Check your email!`,
                                html: `Thank you for submitting your information. We have sent a confirmation email to you with further details.`,
                                icon: `success`,
                                confirmButtonText: `Close`
                            })
                            .then(() => {
                                window.location.href = `/`;
                            });
                    } else {
                        Swal
                            .fire({
                                title: `An error occurred`,
                                html: res.data.errorText,
                                icon: `error`,
                                confirmButtonText: `Close`
                            });
                    }
                })
                .catch((error) => {
                    Swal
                        .fire({
                            title: `An error occurred`,
                            html: `Something went wrong while submitting your request. Please try again later.`,
                            icon: `error`,
                            confirmButtonText: `Close`
                        });
                })
        )
    }

    return (
        <>
            {loader.asJsx || (
                <>
                    <div style={{ maxWidth: 1000 + 'px', width: 100 + '%' }}>
                        <Form className="text-center w-100" onSubmit={insertLead}>
                            <p className="w-100 fw-bold mb-4">Claim your free, personalized business assessment and discover the right solution for you</p>
                            <div className="row mb-1">
                                <div className="col-12 col-md-6">
                                    <FormGroup className="w-100 mb-4">
                                        <FormControl className="form-control-lg border-white" type="text" name="full_name" placeholder="Full name" onChange={handleChange} required></FormControl>
                                    </FormGroup>
                                </div>
                                <div className="col-12 col-md-6">
                                    <FormGroup className="w-100 mb-4">
                                        <FormControl className="form-control-lg border-white" type="text" name="company_name" placeholder="Company name" onChange={handleChange} required></FormControl>
                                    </FormGroup>
                                </div>
                                <div className="col-12 col-md-6">
                                    <FormGroup className="w-100 mb-4">
                                        <FormControl className="form-control-lg border-white" type="text" name="business_address" placeholder="Business address" onChange={handleChange} required></FormControl>
                                    </FormGroup>
                                </div>
                                <div className="col-12 col-md-6">
                                    <FormGroup className="w-100 mb-4">
                                        <FormControl className="form-control-lg border-white" type="text" name="city" placeholder="City" onChange={handleChange} required></FormControl>
                                    </FormGroup>
                                </div>
                                <div className="col-12 col-md-6">
                                    <FormGroup className="w-100 mb-4">
                                        <FormControl className="form-control-lg border-white" type="email" name="email" placeholder="Email address" onChange={handleChange} required></FormControl>
                                    </FormGroup>
                                </div>
                                <div className="col-12 col-md-6">
                                    <FormGroup className="w-100 mb-4">
                                        <FormControl className="form-control-lg border-white" type="text" name="phone_number" placeholder="Phone number" onChange={handleChange} required></FormControl>
                                    </FormGroup>
                                </div>
                            </div>
                            <p className="w-100 small mb-5"><i>Our experts will review your answers and contact you with personalized recommendations. No spam. No obligation.</i></p>
                            <Button type="submit" className="btn-fiducia">Get my free assessment</Button>
                        </Form>
                    </div>
                </>
            )}
        </>
    );
}

export default Step6;